exports = module.exports = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".details-box[data-v-d3a531de]{margin-bottom:35px}.details-box[data-v-d3a531de]  .item-label{color:#979797;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.details-box[data-v-d3a531de]  .item-content{color:#686868}.details-box .item-tip[data-v-d3a531de]{color:#f37126;margin-left:5px}", ""]);

// exports
